import { render, staticRenderFns } from "./TsLoginPage.vue?vue&type=template&id=354c482a&scoped=true"
import script from "./TsLoginPage.vue?vue&type=script&lang=js"
export * from "./TsLoginPage.vue?vue&type=script&lang=js"
import style0 from "./TsLoginPage.vue?vue&type=style&index=0&id=354c482a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c482a",
  null
  
)

export default component.exports